import { Link } from 'react-router-dom'
import { SITE, mailto } from '../lib/site'

export default function Footer() {
  return (
    <footer className="border-t border-[var(--color-border)] bg-[var(--color-bg-elev)]">
      <div className="container-page py-10">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 font-mono text-sm font-medium">
              <span className="grid h-7 w-7 place-items-center rounded bg-[var(--color-accent)] text-white">W</span>
              <span>W.Sign</span>
            </div>
            <p className="mt-3 max-w-md text-sm text-[var(--color-fg-muted)]">
              Kurumsal e-imza ve doğrulama altyapısı. CAdES, XAdES, PAdES; AKİS / SafeNet token
              desteği; KamuSM RFC 3161 zaman damgası; OCSP / CRL doğrulama. Belgeleriniz sizin
              kontrolünüzde, kurumsal destek.
            </p>
            <p className="mt-4 text-sm text-[var(--color-fg-dim)]">
              {SITE.company} · {SITE.city}
            </p>
            <a href={mailto(SITE.email.general)} className="text-sm text-[var(--color-fg-muted)] hover:text-[var(--color-accent)]">
              {SITE.email.general}
            </a>
            {SITE.phone && (
              <span className="block text-sm text-[var(--color-fg-muted)]">{SITE.phone}</span>
            )}
          </div>

          <div>
            <h4 className="text-sm font-semibold text-[var(--color-fg)]">Ürün</h4>
            <ul className="mt-3 space-y-1.5 text-sm text-[var(--color-fg-muted)]">
              <li><Link to="/verify"          className="hover:text-[var(--color-fg)]">Doğrulama Portalı</Link></li>
              <li><Link to="/sign"            className="hover:text-[var(--color-fg)]">İmzala</Link></li>
              <li><Link to="/download"        className="hover:text-[var(--color-fg)]">İndirmeler</Link></li>
              <li><Link to="/docs"            className="hover:text-[var(--color-fg)]">Geliştirici dokümanı</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-[var(--color-fg)]">Kurumsal</h4>
            <ul className="mt-3 space-y-1.5 text-sm text-[var(--color-fg-muted)]">
              <li><Link to="/hakkimizda"      className="hover:text-[var(--color-fg)]">Hakkımızda</Link></li>
              <li><Link to="/destek"          className="hover:text-[var(--color-fg)]">Destek</Link></li>
              <li><Link to="/gizlilik"        className="hover:text-[var(--color-fg)]">Gizlilik &amp; KVKK</Link></li>
              <li><a href={SITE.corpUrl} target="_blank" rel="noopener" className="hover:text-[var(--color-fg)]">WSOFT</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-[var(--color-border)] pt-6 text-xs text-[var(--color-fg-dim)] md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} {SITE.company}. Tüm hakları saklıdır.</p>
          <p className="font-mono">sign.wsoft.tr</p>
        </div>
      </div>
    </footer>
  )
}
